const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmex(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.205646,0,0,0.205646,0,-9.43807e-09)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.235,41.025L273.529,41.025C283.595,41.025 291.764,49.194 291.764,59.269L291.764,232.504C291.764,242.57 283.595,250.739 273.529,250.739L18.235,250.739C8.16,250.74 0,242.57 0,232.505L0,59.269C0,49.194 8.169,41.025 18.235,41.025Z",
    style: {
      fill: "rgb(38,166,209)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.047,113.966L18.235,177.726L52.727,177.726L57.003,167.56L66.777,167.56L71.053,177.726L109.019,177.726L109.019,169.967L112.402,177.726L132.041,177.726L135.424,169.803L135.424,177.726L214.383,177.726L223.984,167.824L232.974,177.726L273.529,177.808L244.626,146.024L273.529,113.966L233.603,113.966L224.257,123.685L215.55,113.966L129.653,113.966L122.277,130.423L114.728,113.966L80.308,113.966L80.308,121.461L76.479,113.966L47.047,113.966ZM53.721,123.02L70.534,123.02L89.645,166.256L89.645,123.02L108.063,123.02L122.824,154.02L136.428,123.02L154.754,123.02L154.754,168.772L143.603,168.772L143.512,132.921L127.255,168.772L117.28,168.772L100.932,132.921L100.932,168.772L77.992,168.772L73.643,158.515L50.147,158.515L45.807,168.763L33.516,168.763L53.721,123.02ZM164.956,123.02L210.298,123.02L224.166,138L238.481,123.02L252.349,123.02L231.278,146.015L252.349,168.745L237.852,168.745L223.984,153.591L209.596,168.745L164.956,168.745L164.956,123.02ZM61.9,130.761L54.159,149.033L69.632,149.033L61.9,130.761ZM176.153,132.493L176.153,140.845L200.889,140.845L200.889,150.154L176.153,150.154L176.153,159.272L203.898,159.272L216.79,145.842L204.445,132.485L176.153,132.485L176.153,132.493Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/amex.6ea13dc39e9ca771264b6b681075aa32.svg";
export { ForwardRef as ReactComponent };